import resolve from "../../utils/object/resolve.js"
//import { makeApiCall } from "../../../client/src/utils/api/apiUtils.js"
import generateEndpoint from "../../../client/src/utils/generateEndpoint.js"
import buildQueryString from "../../../client/src/utils/api/buildQueryString.js"


const isServer = typeof window === 'undefined';

let makeApiCall = async () => { }; // Will be dynamically loaded on client only

if (!isServer) {
    // Dynamic import so the server doesn't crash
    const module = await import("../../../client/src/utils/api/apiUtils.js");
    makeApiCall = module.makeApiCall;
}

const load = async (data, operation, opState) => {
    let result = null

    let entityKeys = resolve(operation.sourcePath, data)

    opState[operation.targetPath] = []

    if (!Array.isArray(entityKeys)) entityKeys = [entityKeys]

    for (const key of entityKeys) {
        const queryString = buildQueryString(operation.params, data)

        // if key is valid, then we can make the api call
        if (key) {
            const url = generateEndpoint(operation.endpoint, key)
            const item = await makeApiCall(`${url}${queryString}`)
            opState[operation.targetPath].push(item.data)
        }
    }

    // This doesn't retun casue we are not modyfing the data
    if (result) return result
    
    //ALWAYS RETURN AT THE END OF ALL IF STATEMENTS
    return data;
}

export default load